// extracted by mini-css-extract-plugin
export var form = "SubscribeToNewsletter-module--form--804e1";